export const getRoundedReviewRating = (rating: number): number => {
  const result = rating / 2;

  const roundedResult = rating % 2 !== 0 ? parseFloat(result.toFixed(5)) : result;

  return roundedResult;
};
